// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__6yrBi","greenPart":"Logo_greenPart__8ALdz"};